import React from "react";
import { Route, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { useAuth } from "./context/auth.context";
import store from "store";

export const ProtectedRoute = ({ roles, ...rest }) => {
  const loggedUser = store.get("user");
  const { user } = useAuth();

  if (!user || !user.token || user.token === "") {
    return <Redirect to="/login" />;
  } else if (
    user &&
    user.token &&
    user.token !== "" &&
    loggedUser &&
    roles.includes(loggedUser.role)
  ) {
    return <Route {...rest} />;
  }
  return <Redirect to="*" />;
};

ProtectedRoute.propTypes = {
  roles: PropTypes.array.isRequired,
};
